const { NavBar } = require("src/client-ts/containers/NavBar/NavBar");

exports.navBar = NavBar;
